import { render } from "./WuliuList.vue?vue&type=template&id=3f148186&scoped=true"
import script from "./WuliuList.vue?vue&type=script&lang=js"
export * from "./WuliuList.vue?vue&type=script&lang=js"

import "./WuliuList.vue?vue&type=style&index=0&id=3f148186&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f148186"]])

export default __exports__